import { CardInput } from 'spa/components/payment_details/card_input'
import { Layout } from 'spa/components/layout'
import React from 'react'

const display = () => {
  return (
    <Layout fullLayout tabTitle="payment">
      <CardInput />
    </Layout>
  )
}

export { display as PaymentDisplay }
